import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { EYesNo } from '../../../../../shared/models/types.enum';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReviewRoarActivityComponent } from "../../../../components/review-content/review-roar-activity/review-roar-activity.component";

@Component({
  selector: 'roar-review-notes',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ReviewRoarActivityComponent
],
  templateUrl: './roar-review-notes.component.html',
  styleUrl: './roar-review-notes.component.css'
})
export class RoarReviewNotesComponent implements OnInit, OnChanges {

  @Input() roarAssignmentFormData: any;
  @Output() onSaveSection1 = new EventEmitter<any>();
  
  yesNo = EYesNo;
  roarDetailsForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Review Notes: *",
      formControlName: "review_notes",
      type: "textarea"
    },
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['roarAssignmentFormData'] && this.roarAssignmentFormData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.roarAssignmentFormData?.[question.formControlName] || '', Validators.required);
    });

    this.roarDetailsForm = new FormGroup(group);
  }  
  saveRoarDetails(): void {
    if (this.roarDetailsForm.valid) {
        this.onSaveSection1.emit(this.roarDetailsForm.value);
    }
  }

}
